<template>
  <cookie-law theme="mapdrop"
    v-on:close="close"
    v-on:accept="accept">
    <template slot-scope="props">
      <div class="message">
        Diese Seite benutzt Cookies.
        <router-link to="/privacy" class="more-info">
          Mehr Infos
        </router-link>
      </div>
      <div class="buttons">
        <button class="accept" @click="props.accept">
          <span>Akzeptieren</span>
        </button>
        <button class="close" @click="props.close">
          <span>Ignorieren</span>
        </button>
      </div>
    </template>
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  components: {
    CookieLaw
  },
  methods: {
    close () {
      if (process.env.NODE_ENV === 'development') {
        console.log('Cookie banner closed (ignore, opt-out). NOT enabling gtag.')
      }
    },
    accept () {
      if (process.env.NODE_ENV === 'development') {
        console.log('Cookies accepted. Enabling gtag.')
      }
      this.enableGtag()
    },
    enableGtag () {
      this.$gtag.optIn()
    }
  }
}
</script>

<style lang="postcss">
.Cookie--mapdrop {
  background: #9ce2bf;
  color: var(--text-color);
  padding: 0.9rem;
  opacity: 0.9;

  & .close, & .accept {
    font-size: 1rem;
    padding: 0.6rem;
    outline: none;
    border-radius: 0.5rem;
    margin-left: 1.25em;
    margin-top: 0.5em;
    text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.2);

    &:hover {
      box-shadow: 5px 5px 8px -5px rgba(0,0,0,0.65);
    }
  }

  & .accept {
    background-color: var(--main-color);
  }

  & .close {
    background-color: #ccc;
  }

  & .buttons, & .message {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: center;
  }

  & .more-info {
    font-size: smaller;
  }
}
</style>
